<template>
  <div class="history-card-skeleton">
    <div class="skeleton-history-header">
      <div class="skeleton-header-icon"></div>
      <div class="skeleton-header-text"></div>
    </div>
    <div class="skeleton-history-list">
      <div v-for="i in 8" :key="i" class="skeleton-history-item">
        <div class="skeleton-history-left">
          <div class="skeleton-history-image"></div>
          <div class="skeleton-history-name"></div>
        </div>
        <div class="skeleton-history-right">
          <div class="skeleton-history-point"></div>
          <div class="skeleton-history-date"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftHistoryCardSkeleton"
}
</script>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-header-icon,
.skeleton-header-text,
.skeleton-history-image,
.skeleton-history-name,
.skeleton-history-point,
.skeleton-history-date {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.history-card-skeleton {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  box-shadow: none;
}

.skeleton-history-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 12px;
}

.skeleton-header-icon {
  width: 20px;
  height: 20px;
}

.skeleton-header-text {
  height: 18px;
  width: 80px;
}

.skeleton-history-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skeleton-history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #f9fafb;
  border-radius: 8px;
}

.skeleton-history-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.skeleton-history-image {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  flex-shrink: 0;
}

.skeleton-history-name {
  height: 14px;
  width: 80px;
}

.skeleton-history-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.skeleton-history-point {
  height: 14px;
  width: 50px;
}

.skeleton-history-date {
  height: 10px;
  width: 60px;
}

@media (max-width: 1024px) {
  .history-card-skeleton {
    padding: 14px;
  }

  .skeleton-header-text {
    height: 16px;
    width: 70px;
  }
}

@media (max-width: 768px) {
  .history-card-skeleton {
    padding: 12px;
  }

  .skeleton-history-header {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .skeleton-header-text {
    height: 14px;
    width: 60px;
  }

  .skeleton-history-list {
    max-height: 300px;
    overflow-y: auto;
    gap: 8px;
  }

  .skeleton-history-item {
    padding: 8px;
  }

  .skeleton-history-image {
    width: 32px;
    height: 32px;
  }

  .skeleton-history-name {
    height: 12px;
    width: 60px;
  }

  .skeleton-history-point {
    height: 12px;
    width: 40px;
  }

  .skeleton-history-date {
    height: 8px;
    width: 50px;
  }
}

@media (max-width: 576px) {
  .history-card-skeleton {
    padding: 10px;
    border-radius: 10px;
  }

  .skeleton-history-header {
    padding-bottom: 8px;
    margin-bottom: 8px;
    gap: 6px;
  }

  .skeleton-header-icon {
    width: 16px;
    height: 16px;
  }

  .skeleton-header-text {
    height: 14px;
    width: 50px;
  }

  .skeleton-history-list {
    max-height: 300px;
    gap: 6px;
  }

  .skeleton-history-item {
    padding: 8px;
    border-radius: 6px;
  }

  .skeleton-history-left {
    gap: 8px;
  }

  .skeleton-history-image {
    width: 36px;
    height: 36px;
    border-radius: 4px;
  }

  .skeleton-history-name {
    height: 10px;
    width: 50px;
  }

  .skeleton-history-point {
    height: 10px;
    width: 35px;
  }

  .skeleton-history-date {
    height: 8px;
    width: 45px;
  }
}

@media (max-width: 400px) {
  .history-card-skeleton {
    padding: 8px;
  }

  .skeleton-header-text {
    height: 12px;
    width: 45px;
  }

  .skeleton-history-image {
    width: 30px;
    height: 30px;
  }

  .skeleton-history-name {
    height: 10px;
    width: 40px;
  }

  .skeleton-history-point {
    height: 10px;
    width: 30px;
  }

  .skeleton-history-date {
    height: 8px;
    width: 40px;
  }
}

@media (max-width: 576px) {
  .history-card-skeleton {
    min-width: 0;
    min-height: 0;
    max-height: 420px;
    padding: 16px;
  }
}
</style>
